import { useSelector } from 'react-redux';

// Module-level so useSelector gets the same reference and doesn't re-render on every store update
const NO_CATEGORIES = [];

export function useParticipantsCategories(eventId) {
    return useSelector(state => state.events[eventId]?.participants?.categories ?? NO_CATEGORIES);
}
